






















import Vue from "vue";
import { ROUTES } from "@tt-app/constants";

interface Data {
  showModal: boolean;
}

interface Methods {
  handleRoutingToAssignmentList: () => void;
  handleSubmittedModalClose: () => void;
}

interface Computed {
  submittedModalOpen: boolean;
}

interface Props {
  assignmentsCompleted: number;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "AssignmentCompletionModal",

  props: {
    assignmentsCompleted: { type: Number, default: 0 }
  },

  data() {
    return {
      showModal: true
    };
  },

  computed: {
    submittedModalOpen() {
      return this.assignmentsCompleted > 0 && this.showModal;
    }
  },

  methods: {
    handleRoutingToAssignmentList() {
      const assignmentListRouteName = ROUTES.ASSIGNMENT.EXPLORE.NAME;

      this.$router.push({
        name: assignmentListRouteName
      });
    },
    handleSubmittedModalClose() {
      this.showModal = false;
    }
  }
});
